import { QuoteStatus } from '@/utils'

export const TO_CREATE_NEW_CUSTOMER = '/customers/create-new-customer'
export const TO_CUSTOMER_DETAILS = '/customers/customer-profile'
export const BILLING_ADDRESS_ID = 'billingAddressId'
export const QUOTE_SUMMARY_PATH = 'quote-summary'
export const QUOTE_CONFIRMATION_PATH =
  '/quotation-tool/client-quote-confirmation'
export const PREVIEW_QUOTE_CONFIRMATION_PATH =
  '/quotation-tool/preview-quote-confirmation'
export const RESTRICTED_VIEW_MOBILE_DEVICE = '/quotation-tool/restricted-view'
export const All_QUOTES_KEY = 'allQuotesKey'
export const MY_QUOTES_KEY = 'myQuotesKey'
export const SAVED_SPECS_KEY = 'savedSpecsKey'
export const SPEC_DETAILS_KEY = 'specDetailsKey'
export const SAVED_SPECS_PATH = 'saved-specs/'

export const MB = 1000000
export const MAX_FILE_SIZE_APPROVAL = 20 * MB

export const MACHINE_TYPE = {
  ATTACHMENT: 'attachment',
  EQUIPMENT: 'equipment',
  NO_TYPE: ''
} as const

export const EQUIPMENT_TYPE = {
  ATTACHMENT: 'Attachment',
  MACHINE: 'Machine'
} as const

export enum applyToEqSteps {
  CONFLICTS = 'conflicts',
  SELECT_EQ = 'selectEquipment'
}

export enum StockStatuses {
  ON_ORDER = 'On order - Unallocated',
  STOCK = 'In Stock - Unallocated'
}

export enum QuoteType {
  ALL_QUOTES = 'all-quotes',
  MY_QUOTES = 'my-quotes'
}

export enum QuotesSubTabs {
  ACCEPTED = 'Accepted',
  CUSTOMER_APPROVALS = 'Customer Approvals',
  DRAFTS = 'Drafts',
  INTERNAL_APPROVALS = 'Internal Approvals',
  ARCHIVED = 'Archived'
}

export enum PdfDownloadTypes {
  CUSTOMER = 'customer',
  INTERNAL_APPROVAL = 'internalApproval',
  SALES_SUPPORT = 'salesSupport'
}

export const GENERAL_MACHINE_TYPES = {
  ATTACHMENT: 'Attachment',
  MACHINE: 'Machine'
}

export const WARRANTY_TYPES = {
  EXTENDED: 'Extended',
  STANDARD: 'Standard'
}

export const FACTORY_OPTIONS_TYPES = {
  FACTORY_FIT: 'Factory fit',
  STANDARD: 'Standard'
}

export const RULE_ACTIONS = {
  REPLACE: 'replace',
  REQUIRE: 'require',
  SUGGEST: 'suggest'
}

export enum saveSpecSteps {
  NEW = 'newSpec',
  OVERRIDE = 'overrideSpec',
  SAVE_SPEC = 'saveSpec'
}

export enum saveSpecOptions {
  EXISTING = 'existing',
  NEW = 'new'
}

export enum WizardSteps {
  OPTIONS = 0,
  OVERVIEW = 2,
  SERVICES = 1
}

export enum WizardErrorSteps {
  NO_ERROR = -1,
  OPTIONS = 0,
  OVERVIEW = 2,
  SERVICES = 1
}

export const UNPROCESSABLE_REQUEST_CODE = 422

export enum SendQuoteOptions {
  ACCEPT_FOR_CUSTOMER = 'Accept for Customer',
  SEND_TO_CUSTOMER = 'Email PDF to Customer',
  RESEND_TO_CUSTOMER = 'Resend to Customer'
}

export enum QuoteConfirmation {
  ACCEPTED = 'accepted',
  ERROR = 'error',
  REJECTED = 'rejected'
}

export enum AccessDeniedReason {
  EMPTY = 'empty',
  INCOMPLETE = 'incomplete'
}

export const dashedBorder = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='13' ry='13' stroke='%23D7D7D7FF' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='9' stroke-linecap='round'/%3e%3c/svg%3e")`

export enum QuoteDialogType {
  ACCEPT = 'accept',
  REJECT = 'reject'
}

export enum QuotationToolTabs {
  DEAL_SUMMARY = 'dealSummary',
  HISTORY = 'history',
  ITEMS = 'items',
  SAVED_SPECS = 'savedSpecs',
  TRADE_IN = 'tradeIn',
  DRAFTS = 'drafts'
}

export enum QuotationEquipmentsType {
  MACHINE_ATTACHMENT_ITEMS = 'machineAttachmentItems',
  MACHINE_ITEMS = 'machineItems'
}

export const acceptedStatusesForCustomerName = [
  QuoteStatus.DRAFT,
  QuoteStatus.NEEDS_REVISING,
  QuoteStatus.PRICE_CHANGED,
  QuoteStatus.ACCEPTED
]

export const acceptForCustomerDefaultState = {
  evidence: null,
  how: '',
  who: ''
}
